/**
 *  Given two points, returns the bisect point of the line traced between them
 * @param pointA -
 * @param pointB -
 */
export const calculateLineBisect = (
  pointA: {
    x: number;
    y: number;
  },
  pointB: { x: number; y: number },
) => ({
  x: (pointA.x + pointB.x) / 2,
  y: (pointA.y + pointB.y) / 2,
});
